import {
  getPrice,
} from "apps/website/components/feature/PayPalExpressCheckout/v1/get-price";
import {
  PayPalExpressCheckout,
} from "apps/website/components/feature/PayPalExpressCheckout/PayPalExpressCheckout";
import {
  useIsPayPalEnabled,
} from "apps/website/components/feature/PayPalExpressCheckout/useIsPayPalEnabled";
import Column from "apps/website/components/layout/Column/Column";

export const FormPayPalExpressCheckout = ({
  flowId,
  onSuccess,
}: {
  flowId: string;
  onSuccess: () => void;
}) => {
  const isPayPalEnabled = useIsPayPalEnabled();

  // Gate *after* every hook call (Rules of Hooks) but *before* touching the
  // dispatcher tree, so when PostHog has the buyer outside the flag's
  // audience neither the v1/v2 wrappers nor `useCreateBasket` mount and
  // pull form-service / API dependencies for nothing.
  if (!isPayPalEnabled) {
    return null;
  }

  const price = getPrice(flowId);

  return (
    <Column className="gap-4">
      <PayPalExpressCheckout
        version="v1"
        price={ price }
        onSuccess={ onSuccess }
      />
    </Column>
  );
};
